module.exports = __webpack_public_path__ + "8dc084dc28e881951f0f188798046e5c.png";